import { Component, Inject, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { ProcessoService } from '@app/services/processo.service';
import { ProcessoEntrevista } from '@app/models/processo-entrevista';
import { EntrevistaService } from '@app/services/entrevista.service';
import { Entrevista } from '@app/models/entrevista.model';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-entrevista',
  templateUrl: './entrevista.component.html'
})
export class EntrevistaComponent implements OnInit {

  processoEntrevista: ProcessoEntrevista;
  modelos: Entrevista[] = [];
  modeloSelecionado: number = null;
  entrevista: Entrevista;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private processoService: ProcessoService,
    private entrevistaService: EntrevistaService,
    @Inject(ToastrService) public toastr: ToastrService
  ) {
    this.processoEntrevista = new ProcessoEntrevista();
  }

  ngOnInit() {
    this.route.parent.params.subscribe(
      (params: any) => {
        this.processoEntrevista.Id = params['id'];
        this.processoService.obterPorId(this.processoEntrevista.Id).subscribe(data => {
          if (data) {
            if (data.EntrevistaId) {
              this.modeloSelecionado = data.EntrevistaId;
              this.obterModelo();
            } else {
              this.obter();
            }
          }
        });
      });
    this.entrevistaService.obterTodos().subscribe(data => this.modelos = data);
  }

  obterModelo() {
    if (this.modeloSelecionado != null) {
      this.entrevistaService.obterEntrevista(this.modeloSelecionado, this.processoEntrevista.Id).subscribe(data => this.entrevista = data);
    }
  }

  obter() {
    this.processoService.obterEntrevista(this.processoEntrevista.Id).subscribe(data => this.processoEntrevista = data);
  }

  gravar() {
    if (this.modeloSelecionado != null) {
      this.entrevistaService.gravarEntrevista(this.entrevista, this.processoEntrevista.Id).subscribe(() => {
        this.toastr.success('Entrevista gravada com sucesso!');
      },
        () => {
          this.toastr.error('Ops... não foi possível gravar a entrevista tente novamente.');
        });
    } else {
      this.processoService.atualizarEntrevista(this.processoEntrevista).subscribe(() => {
        this.toastr.success('Entrevista gravada com sucesso!');
      },
        () => {
          this.toastr.error('Ops... não foi possível gravar a entrevista tente novamente.');
        });
    }
  }
}
